export interface AuthRuntime {
  getAccessToken(): string | null;
  refresh(): Promise<boolean>;
  onAuthFailure(): void;
}

let runtime: AuthRuntime | null = null;

export function registerAuthRuntime(rt: AuthRuntime): void {
  runtime = rt;
}
export function getAuthRuntime(): AuthRuntime | null {
  return runtime;
}
